import { defineComponent } from 'vue';

import { EDITOR_EVENT } from '@/app/editor/config/constants/trackEventIds';
import { cloneDeep } from '@/utils/common';
import FooterPresetOption from '../../utils/mixins/FooterPresetOption';
import { reRunInit } from '@/modules/gem-meter/GemMeterEngine/Engine/useGemMeterController';
import { generateCssString } from '@modules/global-style';
import { isLandingPage } from '@/modules/gem-meter/GemMeterEngine/Engine/useGemMeterStore';

export default defineComponent({
  mixins: [FooterPresetOption],
  methods: {
    prepareDataUpdatePreset() {
      this.trackEvent({
        eventId: EDITOR_EVENT.GS_UPDATE_BUTTON_CLICKED,
        properties: { type: this.currentPresetOptionType },
      });
      if (!this.obGlobalStyle.firstSavePreset) {
        const payload = cloneDeep(this.shopMeta);
        payload.onboardingGlobalStyle.firstSavePreset = true;
        this.updateShopMeta(payload);
      }
      const presetOptionsInPreset = this.currentPreset.presetOptions;
      const presetOptions = [
        ...presetOptionsInPreset.colors,
        ...presetOptionsInPreset.texts,
        ...presetOptionsInPreset.borders,
        ...presetOptionsInPreset.corners,
        ...presetOptionsInPreset.spacings,
        ...presetOptionsInPreset.buttons,
      ];
      const content = generateCssString(this.currentPreset);

      const params: any = {
        presetId: this.currentPreset.id as number,
        destroy: this.currentPreset.destroy as boolean,
        presetOptions: presetOptions,
        cssStr: content,
      };

      return params;
    },

    updateCurrentPreset() {
      const params = this.prepareDataUpdatePreset();
      this.activeLoading();
      this.ALERT({
        show: true,
        title: 'Updating',
        message: this.currentPreset.name,
        typeAlert: 'info',
        delay: 'infinity',
      });
      return this.savePresetOptions(params)
        .then((response: any) => {
          if (response.errorCode === 'GS00006') {
            this.ALERT({
              show: true,
              title: '',
              message: this.msgAlreadyDelete(this.currentPreset),
              typeAlert: 'error',
            });
          } else {
            this.activeSuccess();
            this.updatePreset(response);
            this.ALERT({
              show: true,
              title: '',
              message: 'Successfully <span class="typo-semibold">saved</span> changes',
              typeAlert: 'success',
            });

            // ===== GemMeter Feature ===== //
            if (isLandingPage()) {
              this.$nextTick(() => {
                setTimeout(() => {
                  reRunInit();
                }, 100);
              });
            }
            // =========================== //
          }
        })
        .catch((error: any) => {
          setTimeout(() => {
            this.activeError();
            let message =
              'Failed to <span class="typo-semibold">save</span> changes. Check your Internet connection and try again later.';
            if (error.response.data.errorCode === 'GS00006') {
              message = this.msgAlreadyDelete(this.currentPreset);
            }
            this.ALERT({
              show: true,
              title: '',
              message: message,
              typeAlert: 'error',
            });
          }, 200);
        })
        .finally(() => {
          setTimeout(() => {
            this.resetStatus();
          }, 500);
        });
    },

    async modalUpdateCurrentPreset() {
      await this.updateCurrentPreset();
    },
  },
});
